export async function executeOnDocumentReady(callback) {
	if (document.readyState === 'loading') {
		await new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
	callback();
}
